export default "__VITE_ASSET__9cebdda1__"